/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 企業Slack通知連携に関するフラグ（企業ごとの機能フラグで利用可）
 * @export
 * @interface GetAccount200ResponseFeatureFlagsSlackNotification
 */
export interface GetAccount200ResponseFeatureFlagsSlackNotification {
    /**
     * 利用可否 true:利用可 false:利用不可
     * @type {boolean}
     * @memberof GetAccount200ResponseFeatureFlagsSlackNotification
     */
    enabled: boolean;
}

/**
 * Check if a given object implements the GetAccount200ResponseFeatureFlagsSlackNotification interface.
 */
export function instanceOfGetAccount200ResponseFeatureFlagsSlackNotification(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "enabled" in value;

    return isInstance;
}

export function GetAccount200ResponseFeatureFlagsSlackNotificationFromJSON(json: any): GetAccount200ResponseFeatureFlagsSlackNotification {
    return GetAccount200ResponseFeatureFlagsSlackNotificationFromJSONTyped(json, false);
}

export function GetAccount200ResponseFeatureFlagsSlackNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAccount200ResponseFeatureFlagsSlackNotification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
    };
}

export function GetAccount200ResponseFeatureFlagsSlackNotificationToJSON(value?: GetAccount200ResponseFeatureFlagsSlackNotification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
    };
}

